import parse from 'html-react-parser';
import { FC } from 'react';

import { SolutionType } from '../../types';
import ThemeLink from '../theme-link/theme-link';

type PropType = {
  className: string;
  index: number;
} & SolutionType;

const ThemeTipsItem: FC<PropType> = ({ className, index, title, description, externalLink }) => (
  <div className={className}>
    <h4>
      {index + 1}. {title}
    </h4>
    <p>{parse(description ?? '')}</p>
    {externalLink && <ThemeLink {...externalLink} />}
  </div>
);

export default ThemeTipsItem;
